import React, { useState } from 'react';
import { galleryImages } from '../mock';
import { X } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8 bg-black border-2 border-silver rounded-3xl mb-8">
      <div className="container mx-auto">
        <h2 className="text-xl sm:text-[3.2vw] md:text-[3vw] lg:text-[2.85vw] text-center mb-8 sm:mb-16 text-gold font-semibold sm:whitespace-nowrap" style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}>
          Performance Gallery
        </h2>
        
        <div className="relative px-10 sm:px-16 md:px-12">
          <Carousel
            plugins={[
              Autoplay({
                delay: 3000,
              }),
            ]}
            opts={{
              align: "center",
              loop: true,
            }}
            className="w-full max-w-6xl mx-auto"
          >
            <CarouselContent className="items-center">
              {galleryImages.map((image) => (
                <CarouselItem key={image.id} className="basis-full flex justify-center px-2">
                  <div
                    onClick={() => setSelectedImage(image)}
                    className="group relative overflow-hidden rounded-lg cursor-pointer border-2 border-gold/20 hover:border-gold transition-all duration-300 bg-black"
                  >
                    <img
                      src={image.src}
                      alt=""
                      title=""
                      className="max-h-[280px] sm:max-h-[400px] md:max-h-[500px] w-auto object-contain group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious 
              variant="default" 
              className="nav-arrow-static !bg-gold !text-black !border-gold h-8 w-8 sm:h-10 sm:w-10" 
              style={{ position: 'absolute', left: '-2.25rem', top: '50%', transform: 'translateY(-50%)' }}
            />
            <CarouselNext 
              variant="default" 
              className="nav-arrow-static !bg-gold !text-black !border-gold h-8 w-8 sm:h-10 sm:w-10" 
              style={{ position: 'absolute', right: '-2.25rem', top: '50%', transform: 'translateY(-50%)' }}
            />
          </Carousel>
        </div>
      </div>
      
      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-gold hover:text-gold/80 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <div className="max-w-6xl max-h-[90vh] relative">
            <img
              src={selectedImage.src}
              alt=""
              title=""
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
